<template>
	<div class="camera">
		<div class="wrapper">
			<button @click="close" class="button-close">
				x
			</button>
			<a
					href="#"
					v-if="isCameraOpen"
					@click.prevent="inverterCamera()"
					class="btn-inverter"
				>
				{{ _traducao('global', 'inverter') }}
			</a>
			<button class="button-snap" @click="toggleCamera()">
				<span v-if="!isCameraOpen">Abrir câmera</span>
				<span v-else>Fechar câmera</span>
			</button>
			<div class="video-container">
				<video
					v-show="isCameraOpen"
					class="camera-video"
					ref="camera"
					:width="videoWidth"
					:height="videoHeight"
					autoplay
					playsinline
				></video>
				<canvas
					id="photoTaken"
					v-show="isPhotoTaken"
					class="canvas-photo"
					ref="canvas"
					:width="canvasWidth"
					:height="canvasHeight"
				></canvas>
			</div>
			<button
				v-if="!isPhotoTaken && isCameraOpen"
				class="button-snap"
				@click="takePhoto"
			>
				<span>Registrar foto</span>
			</button>
			<button v-show="isPhotoTaken && isCameraOpen" class="camera-download">
				<a
					id="downloadPhoto"
					download="VueRocksPhoto.jpg"
					class="button"
					role="button"
					@click="downloadImage"
				>
					Baixar
				</a>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Camera',
	data() {
		return {
			isCameraOpen: false,
			isPhotoTaken: false,
			video: true,
			canvasWidth: 300,
			canvasHeight: 357,
			videoWidth: 300,
			videoHeight: 357,
			currentStream: '',
		}
	},
	methods: {
		close() {
			this.$emit('close-camera')
		},
		inverterCamera() {
			if (_.isObject(this.video)) {
				this.video = true
			} else {
				this.video = {
					facingMode: { exact: 'environment' }
				}
			}
			if (this.currentStream) {
				this.currentStream.getTracks().forEach((track) => track.stop());
			}
			this.createCameraElement()
		},
		createCameraElement() {
			const video = this.video
			const constraints = (window.constraints = {
				audio: false,
				video
			})
			

			navigator.mediaDevices
				.getUserMedia(constraints)
				.then((stream) => {
					this.currentStream = stream 
					this.$refs.camera.srcObject = stream
				})
				.catch((error) => {
					alert(
						error,
						"May the browser didn't support or there is some errors."
					)
				})
		},
		stopCameraStream() {
			const tracks = this.$refs.camera.srcObject.getTracks()

			tracks.forEach((track) => {
				track.stop()
			})
		},
		toggleCamera() {
			if (this.isCameraOpen) {
				this.isCameraOpen = false
				this.isPhotoTaken = false
				this.stopCameraStream()
			} else {
				this.isCameraOpen = true
				this.createCameraElement()
			}
		},
		takePhoto() {
			this.isPhotoTaken = !this.isPhotoTaken
			const context = this.$refs.canvas.getContext('2d')
			const photoFromVideo = this.$refs.camera

			context.drawImage(photoFromVideo, 0, 0, this.videoWidth, this.videoHeight)
			this.downloadImage()
		},
		downloadImage() {
			const download = document.getElementById('downloadPhoto')
			const canvas = document
				.getElementById('photoTaken')
				.toDataURL('image/jpg')
			const imgString = canvas
			this.$emit('image-taken', imgString)
			download.setAttribute('href', canvas)
			this.toggleCamera()
		}
	}
}
</script>

<style>
.camera {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	background: rgba(0, 0, 0, 0.45);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 999;
}

.wrapper {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: 85%;
	height: 90%;
	background-color: white;
	border-radius: 5px;
}

@media (min-width: 600px) {
	.wrapper {
		width: 50%;
	}
}

button {
	font-size: 25px;
	cursor: pointer;
}

.btn-inverter {
	position: absolute;
	top: 30px;
	left: 15px;
}

.button-close {
	position: absolute;
	top: 30px;
	right: 30px;
	width: 25px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.button-snap {
	width: 165px;
	height: 45px;
}

.video-container {
	display: flex;
	flex-direction: column;
}
</style>